import styled from 'styled-components';

const SkeletonContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: center;
`;

const SkeletonTitle = styled.div`
  width: 150px;
  height: 32px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 8px;
  margin: 0 auto 1rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const SkeletonDesc = styled.div`
  width: 100%;
  max-width: 600px;
  height: 20px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 4px;
  margin: 0 auto 2rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const SkeletonFilter = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const SkeletonButton = styled.div`
  width: 80px;
  height: 36px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 20px;
`;

const SkeletonGrid = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
  width: 100%;
  padding: 0 2rem;
`;

const SkeletonCard = styled.div`
  width: 100%;
  max-width: 300px;
  height: 320px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 10px;
  padding: 1.5rem;
`;

const SkeletonImage = styled.div`
  width: 100%;
  height: 150px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card} 25%,
    ${({ theme }) => theme.card_light} 50%,
    ${({ theme }) => theme.card} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 8px;
  margin-bottom: 1rem;
`;

const SkeletonTags = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const SkeletonTag = styled.div`
  width: 60px;
  height: 24px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card} 25%,
    ${({ theme }) => theme.card_light} 50%,
    ${({ theme }) => theme.card} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 15px;
`;

const SkeletonProjectTitle = styled.div`
  width: 80%;
  height: 20px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 4px;
  margin: 0 auto;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const ProjectsSkeleton = ({ $isRTL = false }) => (
  <SkeletonContainer $isRTL={$isRTL}>
    <SkeletonTitle $isRTL={$isRTL} className="skeleton-enhanced" />
    <SkeletonDesc $isRTL={$isRTL} className="skeleton-enhanced" />
    <SkeletonFilter>
      {[...Array(3)].map((_, i) => (
        <SkeletonButton key={i} className="skeleton-enhanced" />
      ))}
    </SkeletonFilter>
    <SkeletonGrid>
      {[...Array(2)].map((_, i) => (
        <SkeletonCard key={i} className="skeleton-enhanced">
          <SkeletonImage className="skeleton-enhanced-dark" />
          <SkeletonTags>
            <SkeletonTag className="skeleton-enhanced-dark" />
            <SkeletonTag className="skeleton-enhanced-dark" />
          </SkeletonTags>
          <SkeletonProjectTitle $isRTL={$isRTL} className="skeleton-enhanced" />
        </SkeletonCard>
      ))}
    </SkeletonGrid>
  </SkeletonContainer>
);

export default ProjectsSkeleton;
